import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  min-height: calc(100vh - 64px);
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 80px;

  .qrcode-container {
    background-color: ${theme.white};
    max-width: 600px;
    width: 100%;
    padding: 40px;
    border-radius: 30px;
    text-align: center;

    .text-subtitle {
      padding-top: 5px;
      white-space: pre-wrap;
    }

    .detail-block {
      display: none;
    }
  }

  .button-prev {
    margin-top: 30px;
  }

  @media (max-width: ${breakpoint.md}) {
    .qrcode-container {
      max-width: 100%;
      padding: 30px;

      .text-subtitle {
        white-space: unset;
      }

      .detail-block {
        display: block;
        .detail {
          padding: 20px 0 !important;
        }
      }
    }
  }
`
